import * as i0 from '@angular/core';
import * as i1 from './chat.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@angular/router';
import * as i5 from '../icon/icon.component';
import * as i6 from '../input/input.directive';
import * as i7 from '../button/button.component';
import * as i8 from './chat.component';
import * as i9 from './chat-message.component';
import * as i10 from './chat-form.component';
import * as i11 from './chat-message-text.component';
import * as i12 from './chat-message-file.component';
import * as i13 from './chat-message-quote.component';
import * as i14 from './chat-message-map.component';
import * as i15 from '../shared/shared.module';
import * as i16 from '../icon/icon.module';
import * as i17 from '../input/input.module';
import * as i18 from '../button/button.module';
export const ElChatModuleNgFactory:i0.NgModuleFactory<i1.ElChatModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_y = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.NgFormSelectorWarning = (<any>(null as any));
var _decl0_33:i4.RouterOutlet = (<any>(null as any));
var _decl0_34:i4.RouterLink = (<any>(null as any));
var _decl0_35:i4.RouterLinkWithHref = (<any>(null as any));
var _decl0_36:i4.RouterLinkActive = (<any>(null as any));
var _decl0_37:i4.ɵangular_packages_router_router_l = (<any>(null as any));
var _decl0_38:i5.ElIconComponent = (<any>(null as any));
var _decl0_39:i6.ElInputDirective = (<any>(null as any));
var _decl0_40:i7.ElButtonComponent = (<any>(null as any));
var _decl0_41:i8.ElChatComponent = (<any>(null as any));
var _decl0_42:i9.ElChatMessageComponent = (<any>(null as any));
var _decl0_43:i10.ElChatFormComponent = (<any>(null as any));
var _decl0_44:i11.ElChatMessageTextComponent = (<any>(null as any));
var _decl0_45:i12.ElChatMessageFileComponent = (<any>(null as any));
var _decl0_46:i13.ElChatMessageQuoteComponent = (<any>(null as any));
var _decl0_47:i14.ElChatMessageMapComponent = (<any>(null as any));
var _decl0_48:i2.AsyncPipe = (<any>(null as any));
var _decl0_49:i2.UpperCasePipe = (<any>(null as any));
var _decl0_50:i2.LowerCasePipe = (<any>(null as any));
var _decl0_51:i2.JsonPipe = (<any>(null as any));
var _decl0_52:i2.SlicePipe = (<any>(null as any));
var _decl0_53:i2.DecimalPipe = (<any>(null as any));
var _decl0_54:i2.PercentPipe = (<any>(null as any));
var _decl0_55:i2.TitleCasePipe = (<any>(null as any));
var _decl0_56:i2.CurrencyPipe = (<any>(null as any));
var _decl0_57:i2.DatePipe = (<any>(null as any));
var _decl0_58:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_59:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_60:i2.KeyValuePipe = (<any>(null as any));
var _decl0_61:i15.ElSharedModule = (<any>(null as any));
var _decl0_62:i16.ElIconModule = (<any>(null as any));
var _decl0_63:i17.ElInputModule = (<any>(null as any));
var _decl0_64:i18.ElButtonModule = (<any>(null as any));
var _decl0_65:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_66:i0.ElementRef<any> = (<any>(null as any));
function _View_ElChatComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_41.tiny;
  currVal_0;
  const currVal_1:any = _decl0_41.small;
  currVal_1;
  const currVal_2:any = _decl0_41.medium;
  currVal_2;
  const currVal_3:any = _decl0_41.large;
  currVal_3;
  const currVal_4:any = _decl0_41.giant;
  currVal_4;
  const currVal_5:any = _decl0_41.primary;
  currVal_5;
  const currVal_6:any = _decl0_41.success;
  currVal_6;
  const currVal_7:any = _decl0_41.info;
  currVal_7;
  const currVal_8:any = _decl0_41.warning;
  currVal_8;
  const currVal_9:any = _decl0_41.danger;
  currVal_9;
}
function _View_ElChatComponent_1_1():void {
  if (!((_decl0_41.messages == null)? (null as any): _decl0_41.messages.length)) { var _any:any = (null as any); }
}
function _View_ElChatComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_41.title;
  currVal_0;
  const currVal_1:any = !((_decl0_41.messages == null)? (null as any): _decl0_41.messages.length);
  currVal_1;
}
function _View_ElChatMessageComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42.flyInOut;
  currVal_0;
  const currVal_1:any = _decl0_42.notReply;
  currVal_1;
  const currVal_2:any = _decl0_42.reply;
  currVal_2;
}
function _View_ElChatMessageComponent_2_2():void {
  if ((!_decl0_42.reply && !_decl0_42.avatarStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_42.getInitials();
    currVal_0;
  }
}
function _View_ElChatMessageComponent_2_1():void {
  if (!_decl0_42.reply) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_42.avatarStyle;
    currVal_0;
    const currVal_1:any = !_decl0_42.avatarStyle;
    currVal_1;
  }
}
function _View_ElChatMessageComponent_2_3():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42.message;
  currVal_0;
  const currVal_1:any = _decl0_42.sender;
  currVal_1;
  const currVal_2:any = _decl0_42.date;
  currVal_2;
  const currVal_3:any = _decl0_42.files;
  currVal_3;
}
function _View_ElChatMessageComponent_2_4():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42.message;
  currVal_0;
  const currVal_1:any = _decl0_42.sender;
  currVal_1;
  const currVal_2:any = _decl0_42.date;
  currVal_2;
  const currVal_3:any = _decl0_42.quote;
  currVal_3;
}
function _View_ElChatMessageComponent_2_5():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42.message;
  currVal_0;
  const currVal_1:any = _decl0_42.sender;
  currVal_1;
  const currVal_2:any = _decl0_42.date;
  currVal_2;
  const currVal_3:any = _decl0_42.latitude;
  currVal_3;
  const currVal_4:any = _decl0_42.longitude;
  currVal_4;
}
function _View_ElChatMessageComponent_2_6():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_42.sender;
  currVal_0;
  const currVal_1:any = _decl0_42.message;
  currVal_1;
  const currVal_2:any = _decl0_42.date;
  currVal_2;
}
function _View_ElChatMessageComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = !_decl0_42.reply;
  currVal_0;
  const currVal_1:any = _decl0_42.type;
  currVal_1;
  const currVal_2:any = 'file';
  currVal_2;
  const currVal_3:any = 'quote';
  currVal_3;
  const currVal_4:any = 'map';
  currVal_4;
}
function _View_ElChatFormComponent_Host_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_43.fileOver;
  currVal_0;
  const pd_1:any = ((<any>_decl0_43.onDrop(_any)) !== false);
  const pd_2:any = ((<any>_decl0_43.onDragOver()) !== false);
  const pd_3:any = ((<any>_decl0_43.onDragLeave()) !== false);
}
function _View_ElChatFormComponent_3_3():void {
  if ((((_decl0_43.droppedFiles == null)? (null as any): _decl0_43.droppedFiles.length) && _any.urlStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.urlStyle;
    currVal_0;
    const pd_1:any = ((<any>_decl0_43.removeFile(_any)) !== false);
  }
}
function _View_ElChatFormComponent_3_4():void {
  if ((((_decl0_43.droppedFiles == null)? (null as any): _decl0_43.droppedFiles.length) && !_any.urlStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = 'file-text-outline';
    currVal_0;
    const currVal_1:any = 'endlessjs-essentials';
    currVal_1;
    const currVal_2:any = _decl0_38.html;
    currVal_2;
    const currVal_3:any = _decl0_38.primary;
    currVal_3;
    const currVal_4:any = _decl0_38.info;
    currVal_4;
    const currVal_5:any = _decl0_38.success;
    currVal_5;
    const currVal_6:any = _decl0_38.warning;
    currVal_6;
    const currVal_7:any = _decl0_38.danger;
    currVal_7;
  }
}
function _View_ElChatFormComponent_3_2():void {
  if (((_decl0_43.droppedFiles == null)? (null as any): _decl0_43.droppedFiles.length)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.urlStyle;
    currVal_0;
    const currVal_1:any = !_any.urlStyle;
    currVal_1;
    const pd_2:any = ((<any>_decl0_43.removeFile(_any)) !== false);
  }
}
function _View_ElChatFormComponent_3_1():void {
  if (((_decl0_43.droppedFiles == null)? (null as any): _decl0_43.droppedFiles.length)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_43.droppedFiles;
    currVal_0;
  }
}
function _View_ElChatFormComponent_3_6():void {
  if ((_decl0_43.showButton && !_decl0_43.buttonTitle)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_43.buttonIcon;
    currVal_0;
    const currVal_1:any = 'endlessjs-essentials';
    currVal_1;
    const currVal_2:any = _decl0_38.html;
    currVal_2;
    const currVal_3:any = _decl0_38.primary;
    currVal_3;
    const currVal_4:any = _decl0_38.info;
    currVal_4;
    const currVal_5:any = _decl0_38.success;
    currVal_5;
    const currVal_6:any = _decl0_38.warning;
    currVal_6;
    const currVal_7:any = _decl0_38.danger;
    currVal_7;
  }
}
function _View_ElChatFormComponent_3_7():void {
  if (_decl0_43.showButton) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_43.buttonTitle;
    currVal_0;
  }
}
function _View_ElChatFormComponent_3_5():void {
  if (_decl0_43.showButton) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_43.status || 'primary');
    currVal_0;
    const currVal_1:any = _decl0_40.filled;
    currVal_1;
    const currVal_2:any = _decl0_40.outline;
    currVal_2;
    const currVal_3:any = _decl0_40.ghost;
    currVal_3;
    const currVal_4:any = _decl0_40.hero;
    currVal_4;
    const currVal_5:any = _decl0_40.fullWidth;
    currVal_5;
    const currVal_6:any = _decl0_40.disabled;
    currVal_6;
    const currVal_7:any = _decl0_40.disabled;
    currVal_7;
    const currVal_8:any = _decl0_40.tabbable;
    currVal_8;
    const currVal_9:any = _decl0_40.tiny;
    currVal_9;
    const currVal_10:any = _decl0_40.small;
    currVal_10;
    const currVal_11:any = _decl0_40.medium;
    currVal_11;
    const currVal_12:any = _decl0_40.large;
    currVal_12;
    const currVal_13:any = _decl0_40.giant;
    currVal_13;
    const currVal_14:any = _decl0_40.primary;
    currVal_14;
    const currVal_15:any = _decl0_40.info;
    currVal_15;
    const currVal_16:any = _decl0_40.success;
    currVal_16;
    const currVal_17:any = _decl0_40.warning;
    currVal_17;
    const currVal_18:any = _decl0_40.danger;
    currVal_18;
    const currVal_19:any = _decl0_40.rectangle;
    currVal_19;
    const currVal_20:any = _decl0_40.round;
    currVal_20;
    const currVal_21:any = _decl0_40.semiRound;
    currVal_21;
    const currVal_22:any = _decl0_40.iconLeft;
    currVal_22;
    const currVal_23:any = _decl0_40.iconRight;
    currVal_23;
    const currVal_24:any = _decl0_40.transitions;
    currVal_24;
    const currVal_25:any = !_decl0_43.buttonTitle;
    currVal_25;
    const currVal_26:any = !_decl0_43.buttonTitle;
    currVal_26;
    const currVal_27:any = _decl0_65;
    currVal_27;
    const pd_28:any = ((<any>_decl0_40.onClick(_any)) !== false);
    const pd_29:any = ((<any>_decl0_43.sendMessage()) !== false);
  }
}
function _View_ElChatFormComponent_3_0():void {
  var _any:any = (null as any);
  const currVal_0:any = ((_decl0_43.droppedFiles == null)? (null as any): _decl0_43.droppedFiles.length);
  currVal_0;
  const currVal_1:any = _decl0_43.message;
  currVal_1;
  const currVal_2:any = _decl0_21.ngClassUntouched;
  currVal_2;
  const currVal_3:any = _decl0_21.ngClassTouched;
  currVal_3;
  const currVal_4:any = _decl0_21.ngClassPristine;
  currVal_4;
  const currVal_5:any = _decl0_21.ngClassDirty;
  currVal_5;
  const currVal_6:any = _decl0_21.ngClassValid;
  currVal_6;
  const currVal_7:any = _decl0_21.ngClassInvalid;
  currVal_7;
  const currVal_8:any = _decl0_21.ngClassPending;
  currVal_8;
  const currVal_9:any = _decl0_43.getInputStatus();
  currVal_9;
  const currVal_10:any = '';
  currVal_10;
  const currVal_11:any = _decl0_39.fullWidth;
  currVal_11;
  const currVal_12:any = _decl0_39.tiny;
  currVal_12;
  const currVal_13:any = _decl0_39.small;
  currVal_13;
  const currVal_14:any = _decl0_39.medium;
  currVal_14;
  const currVal_15:any = _decl0_39.large;
  currVal_15;
  const currVal_16:any = _decl0_39.giant;
  currVal_16;
  const currVal_17:any = _decl0_39.primary;
  currVal_17;
  const currVal_18:any = _decl0_39.info;
  currVal_18;
  const currVal_19:any = _decl0_39.success;
  currVal_19;
  const currVal_20:any = _decl0_39.warning;
  currVal_20;
  const currVal_21:any = _decl0_39.danger;
  currVal_21;
  const currVal_22:any = _decl0_39.rectangle;
  currVal_22;
  const currVal_23:any = _decl0_39.semiRound;
  currVal_23;
  const currVal_24:any = _decl0_39.round;
  currVal_24;
  const currVal_25:any = _decl0_43.showButton;
  currVal_25;
  const currVal_26:any = i0.ɵinlineInterpolate(1,'',(_decl0_43.fileOver? 'Drop file to send': 'Type a message'),
      '');
  currVal_26;
  const currVal_27:any = _decl0_43.showButton;
  currVal_27;
  const pd_28:any = ((<any>(<any>_decl0_14)._handleInput(_any.target.value)) !== false);
  const pd_29:any = ((<any>_decl0_14.onTouched()) !== false);
  const pd_30:any = ((<any>(<any>_decl0_14)._compositionStart()) !== false);
  const pd_31:any = ((<any>(<any>_decl0_14)._compositionEnd(_any.target.value)) !== false);
  const pd_32:any = ((<any>(_decl0_43.inputFocus = true)) !== false);
  const pd_33:any = ((<any>(_decl0_43.inputFocus = false)) !== false);
  const pd_34:any = ((<any>(_decl0_43.inputHover = true)) !== false);
  const pd_35:any = ((<any>(_decl0_43.inputHover = false)) !== false);
  const pd_36:any = ((<any>(_decl0_43.message = _any)) !== false);
  const pd_37:any = ((<any>_decl0_43.sendMessage()) !== false);
}
function _View_ElChatMessageTextComponent_Host_4_0():void {
  var _any:any = (null as any);
}
function _View_ElChatMessageTextComponent_4_1():void {
  if ((_decl0_44.sender || _decl0_44.date)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_44.sender;
    currVal_0;
    const currVal_1:any = _decl0_57.transform(_decl0_44.date,'shortTime');
    currVal_1;
  }
}
function _View_ElChatMessageTextComponent_4_2():void {
  if (_decl0_44.message) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_44.message;
    currVal_0;
  }
}
function _View_ElChatMessageTextComponent_4_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_44.sender || _decl0_44.date);
  currVal_0;
  const currVal_1:any = _decl0_44.message;
  currVal_1;
}
function _View_ElChatMessageFileComponent_Host_5_0():void {
  var _any:any = (null as any);
}
function _View_ElChatMessageFileComponent_5_3():void {
  if (((((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) > 1) && (!_any.urlStyle && _any.icon))) {
    var _any:any = (null as any);
    const currVal_0:any = _any.icon;
    currVal_0;
    const currVal_1:any = _decl0_38.html;
    currVal_1;
    const currVal_2:any = _decl0_38.primary;
    currVal_2;
    const currVal_3:any = _decl0_38.info;
    currVal_3;
    const currVal_4:any = _decl0_38.success;
    currVal_4;
    const currVal_5:any = _decl0_38.warning;
    currVal_5;
    const currVal_6:any = _decl0_38.danger;
    currVal_6;
  }
}
function _View_ElChatMessageFileComponent_5_4():void {
  if (((((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) > 1) && _any.urlStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.urlStyle;
    currVal_0;
  }
}
function _View_ElChatMessageFileComponent_5_2():void {
  if ((((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) > 1)) {
    var _any:any = (null as any);
    const currVal_0:any = _any.url;
    currVal_0;
    const currVal_1:any = (!_any.urlStyle && _any.icon);
    currVal_1;
    const currVal_2:any = _any.urlStyle;
    currVal_2;
  }
}
function _View_ElChatMessageFileComponent_5_1():void {
  if ((((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) > 1)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_45.readyFiles;
    currVal_0;
  }
}
function _View_ElChatMessageFileComponent_5_6():void {
  if (((((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) === 1) && (!_decl0_45.readyFiles[0].urlStyle && _decl0_45.readyFiles[0].icon))) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_45.readyFiles[0].icon;
    currVal_0;
    const currVal_1:any = _decl0_38.html;
    currVal_1;
    const currVal_2:any = _decl0_38.primary;
    currVal_2;
    const currVal_3:any = _decl0_38.info;
    currVal_3;
    const currVal_4:any = _decl0_38.success;
    currVal_4;
    const currVal_5:any = _decl0_38.warning;
    currVal_5;
    const currVal_6:any = _decl0_38.danger;
    currVal_6;
  }
}
function _View_ElChatMessageFileComponent_5_7():void {
  if (((((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) === 1) && _decl0_45.readyFiles[0].urlStyle)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_45.readyFiles[0].urlStyle;
    currVal_0;
  }
}
function _View_ElChatMessageFileComponent_5_5():void {
  if ((((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) === 1)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_45.readyFiles[0].url;
    currVal_0;
    const currVal_1:any = (!_decl0_45.readyFiles[0].urlStyle && _decl0_45.readyFiles[0].icon);
    currVal_1;
    const currVal_2:any = _decl0_45.readyFiles[0].urlStyle;
    currVal_2;
  }
}
function _View_ElChatMessageFileComponent_5_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_45.sender;
  currVal_0;
  const currVal_1:any = _decl0_45.message;
  currVal_1;
  const currVal_2:any = _decl0_45.date;
  currVal_2;
  const currVal_3:any = _decl0_45.message;
  currVal_3;
  const currVal_4:any = (((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) > 1);
  currVal_4;
  const currVal_5:any = (((_decl0_45.readyFiles == null)? (null as any): _decl0_45.readyFiles.length) === 1);
  currVal_5;
}
function _View_ElChatMessageQuoteComponent_Host_6_0():void {
  var _any:any = (null as any);
}
function _View_ElChatMessageQuoteComponent_6_1():void {
  if ((_decl0_46.sender || _decl0_46.date)) {
    var _any:any = (null as any);
    const currVal_0:any = _decl0_46.sender;
    currVal_0;
    const currVal_1:any = _decl0_57.transform(_decl0_46.date,'shortTime');
    currVal_1;
  }
}
function _View_ElChatMessageQuoteComponent_6_0():void {
  var _any:any = (null as any);
  const currVal_0:any = (_decl0_46.sender || _decl0_46.date);
  currVal_0;
  const currVal_1:any = _decl0_46.quote;
  currVal_1;
  const currVal_2:any = _decl0_46.message;
  currVal_2;
  const currVal_3:any = _decl0_46.message;
  currVal_3;
}
function _View_ElChatMessageMapComponent_Host_7_0():void {
  var _any:any = (null as any);
}
function _View_ElChatMessageMapComponent_7_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_47.message;
  currVal_0;
  const currVal_1:any = _decl0_47.sender;
  currVal_1;
  const currVal_2:any = _decl0_47.date;
  currVal_2;
  const currVal_3:any = [_decl0_47.file];
  currVal_3;
}
